export default function PublicLayout({ children }: { children: any }) {
    return <>{children}</>;
}
